/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlBulkReportAssetsResult
 */
export interface ControlBulkReportAssetsResult {
    /**
     * 
     * @type {string}
     * @memberof ControlBulkReportAssetsResult
     */
    entity_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlBulkReportAssetsResult
     */
    asset_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlBulkReportAssetsResult
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof ControlBulkReportAssetsResult
     */
    detail?: string;
}

/**
 * Check if a given object implements the ControlBulkReportAssetsResult interface.
 */
export function instanceOfControlBulkReportAssetsResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entity_id" in value;
    isInstance = isInstance && "asset_id" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function ControlBulkReportAssetsResultFromJSON(json: any): ControlBulkReportAssetsResult {
    return ControlBulkReportAssetsResultFromJSONTyped(json, false);
}

export function ControlBulkReportAssetsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlBulkReportAssetsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': json['entity_id'],
        'asset_id': json['asset_id'],
        'status': json['status'],
        'detail': !exists(json, 'detail') ? undefined : json['detail'],
    };
}

export function ControlBulkReportAssetsResultToJSON(value?: ControlBulkReportAssetsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'asset_id': value.asset_id,
        'status': value.status,
        'detail': value.detail,
    };
}

